// RankedList — compact "Name · N" chips with show-more.
// Pure visual; accepts [{name, count}].

import React, { useState } from "react";

const RankedList = ({ items, max = 5, testId, tone = "muted", showCounts = true }) => {
    const [expanded, setExpanded] = useState(false);
    const arr = Array.isArray(items) ? items : [];
    if (!arr.length) return null;
    const view = expanded ? arr : arr.slice(0, max);
    return (
        <div data-testid={testId}>
            <ul className="flex flex-wrap gap-1.5">
                {view.map((it, i) => (
                    <li
                        key={(it.name || "") + i}
                        className={`inline-flex items-baseline gap-1 px-2 py-0.5 rounded border text-[11px] ${tone === "accent" ? "border-[hsl(var(--accent))] bg-[hsl(var(--accent-soft))] text-[hsl(var(--accent-ink))]" : tone === "positive" ? "border-[hsl(var(--positive))]/40 bg-[hsl(var(--positive))]/10 text-[hsl(var(--positive))]" : tone === "warning" ? "border-[hsl(var(--warning))]/50 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" : "border-[hsl(var(--line))] bg-[hsl(var(--surface-raised))] text-[hsl(var(--ink-soft))]"}`}
                    >
                        <span className="truncate max-w-[180px]" title={it.name}>{it.name}</span>
                        {showCounts && typeof it.count === "number" && it.count > 0 && (
                            <span className="text-[hsl(var(--mute))] num text-[10px]">{it.count}</span>
                        )}
                    </li>
                ))}
            </ul>
            {arr.length > max && (
                <button
                    type="button"
                    onClick={() => setExpanded((v) => !v)}
                    data-testid={`${testId}-toggle`}
                    className="text-[11px] font-medium text-[hsl(var(--accent-ink))] hover:underline mt-1.5"
                >
                    {expanded ? "Show fewer" : `Show all ${arr.length}`}
                </button>
            )}
        </div>
    );
};

export default RankedList;
